// ---------------------------------------------------------------------------
// LatencyOverviewSections — the Metric and Latency source cards for a latency
// grader. Read-only: the latency spec is fixed at creation time, so this
// ignores the Overview edit context. Mirrors NumericOverviewSections so the
// grader-type registry owns this markup.
// ---------------------------------------------------------------------------

import { Field, Input } from '@fluentui/react-components';

import { useStyles } from '../../GraderPage.style.js';
import type { OverviewSectionsProps } from '../graderType.types.js';

import { DEFAULT_LATENCY_METRIC_NAME } from './latency.constants.js';

export function LatencyOverviewSections({ judge }: OverviewSectionsProps) {
  const styles = useStyles();
  const latency = judge.latency;

  return (
    <>
      <section className={styles.overviewCard} aria-labelledby="grader-metric">
        <div id="grader-metric" className={styles.overviewCardTitle}>
          Metric
          <span className={styles.overviewCardTitleHelp}>
            Creation-time name the latency value is reported under.
          </span>
        </div>
        <div className={styles.overviewCardFields}>
          <Field
            label="Metric name"
            hint="Name the metric is emitted under (default latencyMs)."
          >
            <Input
              className={styles.fullWidthControl}
              value={latency?.metricName ?? ''}
              placeholder={`default (${DEFAULT_LATENCY_METRIC_NAME})`}
              disabled
            />
          </Field>
        </div>
      </section>

      <section
        className={styles.overviewCard}
        aria-labelledby="grader-latency-source"
      >
        <div id="grader-latency-source" className={styles.overviewCardTitle}>
          Latency source
          <span className={styles.overviewCardTitleHelp}>
            Per-execution expression, resolved fresh for each row.
          </span>
        </div>
        <div className={styles.overviewCardFields}>
          <Field
            label="Latency (ms) expression"
            hint="Expression resolving to the latency in milliseconds."
          >
            <Input
              className={styles.fullWidthControl}
              value={latency?.latencyMs ?? ''}
              placeholder="{{$expr:$.turn.statistics.elapsedTimeMs}}"
              disabled
            />
          </Field>
        </div>
      </section>
    </>
  );
}
